module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts8.8a5f7eff.png";